export type GrowthFunnel = {
  products: number
  traffic_events: number
  inquiries: number
  opportunities: number
  orders: number
}

export async function getGrowthFunnel(): Promise<GrowthFunnel> {
  const response = await fetch('/api/analytics/growth-funnel')
  if (!response.ok) throw new Error('增长漏斗加载失败')
  return response.json() as Promise<GrowthFunnel>
}

export type FactoryApplication = {
  cooperationMode?: 'supply' | 'brand'
  alliance?: 'pet-home' | 'home-living'
  factoryName: string
  city: string
  category: string
  contactName: string
  contactPhone: string
  mainProducts: string
  monthlyCapacity?: string
}

export async function submitFactoryApplication(data: FactoryApplication): Promise<{ application_no: string }> {
  const response = await fetch('/api/factory-applications', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  if (!response.ok) throw new Error('申请提交失败，请稍后重试')
  return response.json() as Promise<{ application_no: string }>
}
